export default "__VITE_ASSET__Dr6TnM51__"